module.exports = __webpack_public_path__ + "img/MTCIHSBC.73223fdc.png";